import { atom } from 'recoil'
import { IEquipment } from '../../Equipment/equipment.types'

export interface IFavouriteEquipmentAtomState {
  items: IEquipment['id'][]
}

const favouriteEquipmentAtom = atom<IFavouriteEquipmentAtomState>({
  key: 'favouriteEquipment',
  default: { items: [] },
})
export default favouriteEquipmentAtom
